import { API } from "./API";

export const fetchPermissions = () => {
  return API.get(`${process.env.REACT_APP_API_URL}/api/permissions/discover`);
};

export const permissionService = {
  fetchPermissions
}; 